import React from 'react';
import {
  List,
  Datagrid,
  Create,
  SimpleForm,
  TextInput,
  translate as t,
} from 'admin-on-rest';

import Edit from '../components/Edit';
import EditButton from '../components/button/EditButton';
import DeleteButton from '../components/button/DeleteButton';
import TranslatableInput from '../components/inputs/TranslatableInput';
import TranslatableField from '../components/fields/TranslatableField';

export const StationList = (props) => (
  <List {...props}>
    <Datagrid>
      <TranslatableField source="title" />
      <EditButton {...props} basePath="/stations" />
      <DeleteButton {...props} basePath="/stations" />
    </Datagrid>
  </List>
);

// eslint-disable-next-line no-shadow
const StationTitle = t(({ record, translate }) => (
  <span>{record ? translate('edit.title', { title: record.name }) : ''}</span>
));

export const StationEdit = (props) => (
  <Edit title={<StationTitle />} {...props}>
    <SimpleForm>
      <TextInput source="name" />
      <TranslatableInput source="title" {...props} />
    </SimpleForm>
  </Edit>
);

export const StationCreate = (props) => (
  <Create {...props}>
    <SimpleForm redirect="list">
      <TextInput source="name" />
      <TranslatableInput source="title" {...props} />
    </SimpleForm>
  </Create>
);
